import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Products', href: '#products' },
    { label: 'Membership', href: '#membership' },
    { label: 'Free Secret', href: '#lead-magnet' },
    { label: 'Videos', href: '#videos' },
    { label: 'About', href: '#about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a0a0f]/95 backdrop-blur-md border-b border-purple-900/40' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/ac6eabdb4cc8c584e68459ed2e8db63e/795a02a9e33dcc555b6c719772e4793b.png"
            alt="Roblox Secrets Logo"
            className="h-10 w-10 object-contain"
          />
          <span className="font-black text-lg md:text-xl text-yellow-400 tracking-widest uppercase hidden sm:block"
            style={{ textShadow: '0 0 12px rgba(250,204,21,0.6)' }}>
            Roblox Secrets
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-gray-300 hover:text-yellow-400 text-sm font-semibold uppercase tracking-wider transition-colors duration-200 hover:drop-shadow-[0_0_8px_rgba(250,204,21,0.8)]"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Desktop CTA */}
        <a
          href="#products"
          className="hidden md:inline-flex items-center gap-2 bg-yellow-400 text-black font-black text-sm uppercase tracking-wider px-5 py-2.5 rounded-full whitespace-nowrap transition-all duration-200 hover:bg-yellow-300 hover:scale-105"
          style={{ boxShadow: '0 0 20px rgba(250,204,21,0.5)' }}
        >
          <i className="ri-lock-unlock-line"></i>
          Unlock Now
        </a>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-yellow-400 text-2xl"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0a0a0f]/98 border-t border-purple-900/40 px-4 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-gray-300 hover:text-yellow-400 text-base font-semibold uppercase tracking-wider py-2 border-b border-purple-900/20 transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#products"
            onClick={() => setMenuOpen(false)}
            className="mt-2 bg-yellow-400 text-black font-black text-sm uppercase tracking-wider px-5 py-3 rounded-full text-center whitespace-nowrap"
            style={{ boxShadow: '0 0 20px rgba(250,204,21,0.5)' }}
          >
            Unlock Secrets Now
          </a>
        </div>
      )}
    </nav>
  );
}
